export async function resolveSerial<T>(promises: Promise<T>[]) {
  const results: T[] = []
  for (const promise of promises) {
    results.push(await promise)
  }

  return results
}

export async function resolveParallel<T>(promises: Promise<T>[]) {
  return Promise.all(promises)
}
